import BitesApi from '..';
import { TGetFeed } from '../../../feed/feed.types';

export const getFeed: TGetFeed = (payload) => BitesApi.post('/feed/', payload);
